var map = {
	"./cat-hd.png": "44bd",
	"./cat-mobile-2.png": "fc5d",
	"./cat-mobile.png": "d75f",
	"./cat-tablet.png": "8113",
	"./dog-hd.png": "2743",
	"./dog-mobile-2.png": "012b",
	"./dog-mobile.png": "930d",
	"./dog-tablet.png": "acd2",
	"./headline.png": "8a69",
	"./ico-bone.png": "cfd3",
	"./ico-drops.png": "b9b8",
	"./logo-dronspot.png": "9e16",
	"./logo-drontal.png": "70b5",
	"./logo-veto.png": "5781",
	"./packshot.png": "13a2",
	"./packshots-desktop.png": "ad2a",
	"./packshots-hd(old).png": "79f9",
	"./packshots-hd_old.png": "f33a",
	"./packshots-mobile(old).png": "fa5e",
	"./packshots-mobile.png": "db35",
	"./packshots-tablet(old).png": "6816",
	"./packshots-tablet_old.png": "a77b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfba";